export interface Response<T = any> {
  code: number;
  msg: string;
  data: T;
}

export type PageResponse<T = any> = Response<{
  count: number;
  list: T[];
  pageIndex: number;
  pageSize: number;
}>;

export type ResponseType<T = any> = Promise<Response<T>>;

export type PageResponseType<T = any> = Promise<PageResponse<T>>;

export enum MFDResponseCode {
  ErrPassportAuth = 10100,
  ReportNotExist = 24009,
  ErrFeishuNonBind = 91001,
  ErrFeishuUnAuth = 91002,
  ErrFeishuAppDocxUnAuth = 91005, // 飞书文档未授权
  ErrFeishuAppNonDocx = 91006, // 不是 docx 文档
}
